import Http from '../common/http';
import ApiUtil from '../utils/api.util';
import axios from 'axios';
const RESOURCE_NAME = 'countries';

var cacheContentList = null;

const ContentAppService = {
  getList() {
    if (cacheContentList !== null) {
      return new Promise((resolve) => {
        resolve({
          data: cacheContentList
        });
      });
    }

    return new Promise(async (resolve) => {
      const {data} = await axios.get(`${process.env.VUE_APP_EDU_APP_API_URL}/cms/notification?limit=50&currentPage=1&active=1`, {
            headers: {
                "Authorization": `Bearer ${process.env.VUE_APP_EDU_APP_TOKEN}`
            }
        });

      cacheContentList = data;

      resolve({
        data: data
      });
    });
  },
};

export default ContentAppService;
